'use client'

import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import { useSectionFooterOverflowMargin } from '@/hooks/useSectionFooterOverflowMargin'

import ForClubsAuthRedirect from './ForClubsAuthRedirect'
import ForClubsBenefits from './ForClubsBenefits'
import ForClubsCta from './ForClubsCta'
import ForClubsHeroIntro from './ForClubsHero'
import { FOR_CLUBS_SECTION_FOOTER_GAP_PX } from './forClubsLandingContent.constants'
import S from './ForClubsLandingContent.module.scss'
import ForClubsMembers from './ForClubsMembers'
import ForClubsRevenueModel from './ForClubsRevenueModel'
import ForClubsSimpleProcess from './ForClubsSimpleProcess'
import ForClubsStatsBar from './ForClubsStatsBar'

const ForClubsLandingContent = ({
  initialStats
}: {
  initialStats?: ModelsPlatformStatsResponse
}) => {
  const rootRef = useSectionFooterOverflowMargin(
    FOR_CLUBS_SECTION_FOOTER_GAP_PX
  )

  return (
    <div ref={rootRef} className={S.root}>
      <ForClubsAuthRedirect />
      <ForClubsHeroIntro />
      <ForClubsStatsBar initialStats={initialStats} />
      <div className={S.simpleProcessBlock}>
        <ForClubsSimpleProcess />
        <ForClubsRevenueModel />
        <ForClubsBenefits />
        {/* Temporarily hidden until we have a real club case study (mock data). */}
        {/* <ForClubsCaseStudy /> */}
        <ForClubsMembers />
        <ForClubsCta />
      </div>
    </div>
  )
}

export default ForClubsLandingContent
